
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/rockset",
      function () {
        return require("private-next-pages/sources/rockset.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/rockset"])
      });
    }
  